import { watch } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-11cd0450"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "export-content"
};
const _hoisted_2 = {
  class: "upload-content"
};
const _hoisted_3 = {
  class: "tip-text"
};
const _hoisted_4 = {
  class: "tip-text-content"
};
const _hoisted_5 = {
  class: "input-wrap m-b-16px"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "渠道:", -1));
const _hoisted_7 = {
  class: "input-wrap"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "飞书链接:", -1));
const _hoisted_9 = {
  class: "bidu-icon-container"
};
const _hoisted_10 = {
  class: "button-wrap"
};
import { ref } from 'vue';
import { message } from 'ant-design-vue';
import { awaitWrap, OK } from '@/common';
import { getProdChannelCodeList, importGoods } from '@/api/goodsSetting';
export default /*#__PURE__*/_defineComponent({
  __name: 'FeishuExportModal',
  props: {
    modalVisible: {
      type: Boolean
    },
    productScene: null,
    dbtId: null,
    prodChnl: null
  },
  emits: ['update:modalVisible', 'refresh'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const columns = ref([{
      title: '行',
      dataIndex: 'rowNum'
    }, {
      title: '列',
      dataIndex: 'colNum'
    }, {
      title: '内购ID',
      dataIndex: 'prodId'
    }, {
      title: '错误信息',
      dataIndex: 'errorMsg'
    }]);
    const feishuLink = ref('');
    const fileList = ref([]);
    const loading = ref(false);
    const showErrorTable = ref(false);
    const errorTableData = ref([]);
    const errorTableBase64 = ref('');
    const chnlOptions = ref([]);
    const prodChnlVal = ref('');
    const closeModal = () => {
      emit('update:modalVisible', false);
      feishuLink.value = '';
      fileList.value = [];
      showErrorTable.value = false;
      errorTableData.value = [];
    };
    const handleSubmit = async () => {
      if (!feishuLink.value) {
        return message.error('请输入飞书文档链接');
      }
      loading.value = true;
      try {
        const formData = new FormData();
        formData.append('type', '1');
        formData.append('docUrl', feishuLink.value);
        formData.append('dbtId', props.dbtId);
        if (props.prodChnl === 'weixin') formData.append('productScene', props.productScene || 'GAME');
        formData.append('prodChnl', prodChnlVal.value);
        const [err, res] = await awaitWrap(importGoods(formData));
        if (res) {
          if (res.code === OK) {
            message.success('解析成功');
            emit('refresh');
            closeModal();
          } else {
            if (res.code !== '500') {
              var _res$data, _res$data2;
              showErrorTable.value = true;
              errorTableData.value = (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.errorDetailList;
              errorTableBase64.value = (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.errorBase64;
            }
          }
        }
        if (err) {
          message.error('解析失败');
        }
      } catch (err) {
        message.error('解析失败');
      } finally {
        loading.value = false;
      }
    };
    const downloadErrorTable = () => {
      try {
        const downloadElement = document.createElement('a');
        downloadElement.download = '商品信息列表.xls';
        downloadElement.href = `data:;base64,${errorTableBase64.value}`; // base64字符串
        document.body.appendChild(downloadElement);
        downloadElement.click();
        document.body.removeChild(downloadElement);
      } catch (err) {
        message.error('下载失败');
      }
    };
    const handleJumpTemplate = () => {
      window.open('https://ewe8txd9jt.feishu.cn/wiki/NsMlwoTyti1Un4kdBOXcAL3OnAb?from=from_copylink', '_blank');
    };
    const handleJump = () => {
      if (prodChnlVal.value === 'aptoide') {
        window.open('https://ewe8txd9jt.feishu.cn/wiki/Yz1jwfyIWi9ig1kaYsecQ3ICnee', '_blank');
        return;
      }
      window.open(props.productScene === 'MALL' ? 'https://ewe8txd9jt.feishu.cn/wiki/YMWdw8q8JioicRkHqw3cbFVHncb' : 'https://ewe8txd9jt.feishu.cn/wiki/SR69wd5TuicRRakNAPycqVnfnFb?from=from_copylink', '_blank');
    };
    const getChnlOptions = async dbtId => {
      const [err, res] = await awaitWrap(getProdChannelCodeList({
        dbtId
      }));
      if (err) return;
      if (res && res.code === OK) {
        var _res$data3;
        chnlOptions.value = (_res$data3 = res.data) === null || _res$data3 === void 0 || (_res$data3 = _res$data3.subChannelVoList) === null || _res$data3 === void 0 ? void 0 : _res$data3.map(item => {
          return {
            label: item.channelName,
            value: item.channelCode
          };
        });
      }
    };
    watch(() => props.modalVisible, val => {
      if (val) {
        getChnlOptions(props.dbtId);
        prodChnlVal.value = props.prodChnl;
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        open: __props.modalVisible,
        title: "飞书上传",
        width: "788px",
        onCancel: closeModal,
        centered: "",
        footer: false
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_svg_icon, {
          "icon-class": "informationIcon"
        }), _createTextVNode(" 请先按模板中的格式编辑内容并上传 ")]), _createVNode(_component_a_button, {
          type: "link",
          class: "tip-text-btn",
          onClick: handleJump
        }, {
          icon: _withCtx(() => [_createVNode(_component_svg_icon, {
            "icon-class": "export"
          })]),
          default: _withCtx(() => [_createTextVNode(" 点击跳转在线模板 ")]),
          _: 1
        })]), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createVNode(_component_a_select, {
          value: prodChnlVal.value,
          "onUpdate:value": _cache[0] || (_cache[0] = $event => prodChnlVal.value = $event),
          options: chnlOptions.value,
          disabled: __props.productScene === 'MALL'
        }, null, 8, ["value", "options", "disabled"])]), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createVNode(_component_a_input, {
          value: feishuLink.value,
          "onUpdate:value": _cache[1] || (_cache[1] = $event => feishuLink.value = $event),
          placeholder: "请输入飞书文档链接"
        }, null, 8, ["value"]), _createVNode(_component_a_button, {
          type: "link",
          class: "tutorial-btn",
          onClick: handleJumpTemplate
        }, {
          default: _withCtx(() => [_createVNode(_component_svg_icon, {
            "icon-class": "tutor",
            class: "tutor-icon"
          }), _createTextVNode(" 查看教程 "), _createElementVNode("span", _hoisted_9, [_createVNode(_component_svg_icon, {
            "icon-class": "bidu",
            class: "bidu-icon"
          })])]),
          _: 1
        })]), showErrorTable.value ? (_openBlock(), _createBlock(_component_a_table, {
          key: 0,
          columns: columns.value,
          "data-source": errorTableData.value,
          pagination: false,
          bordered: true,
          scroll: {
            y: 300
          }
        }, null, 8, ["columns", "data-source"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_10, [showErrorTable.value ? (_openBlock(), _createBlock(_component_a_button, {
          key: 0,
          ghost: "",
          style: {
            "margin-right": "auto"
          },
          type: "primary",
          onClick: downloadErrorTable
        }, {
          default: _withCtx(() => [_createTextVNode(" 下载错误表格 ")]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_a_button, {
          onClick: closeModal
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_a_button, {
          loading: loading.value,
          type: "primary",
          onClick: handleSubmit
        }, {
          default: _withCtx(() => [_createTextVNode("开始解析")]),
          _: 1
        }, 8, ["loading"])])])]),
        _: 1
      }, 8, ["open"]);
    };
  }
});